import './Contributors.css';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import sanityClient from '../../sanityClient.js';
import { contributorsQuery } from '../../queries/contributorQuery.js';
import { StandardLayout } from '../../layouts/StandardLayout.js';
import PortableTextComponent from '../../components/PortableText/PortableText.js';

const ContributorTile = ({contributor}) => {
    return(
        <div className='contributorTile'>
            <h4 className='contributorName'>{contributor.name}</h4>
            <div className='contributorBio'>
                <PortableTextComponent content={contributor.bio} />
            </div>
            <Link to={`/contributors/${contributor.slug.current}`}>see all posts by {contributor.name}</Link>
        </div>
    )
}

export default function Contributors(){
    const [contributorData, setContributorData] = useState(null);

    useEffect(() => {
        sanityClient.fetch(contributorsQuery)
        .then((data) => setContributorData(data))
        .catch(console.error)
    }, [])

    let content = null;
    if(contributorData){
        content = 
        <div className='contributorTiles'>
            {contributorData.map(contributor => <ContributorTile key={contributor._id} contributor={contributor} />)}
        </div>
    } else{
        content = "Loading..."
    }

    return(
        <StandardLayout title={"contributors"} content={content} />
    )
}
